// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"9420a7cd","483":"9691a9cd","912":"1183a657"}[chunkId] + ".chunk.js";
};